module.exports = __webpack_public_path__ + "img/qr.57b024e2.svg";